import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogTitle,
  Button,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  TextField,
  createSvgIcon,
  DialogContent,
  useTheme,
  styled,
} from "@mui/material";
import { makeStyles } from "@material-ui/core";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { cood, vertical } from "../../../config/SelectListData";
import i18n from "../../../locales/i18n";
import {
  EDisplayType,
  ProjectDetailContext,
  UseSnackbarContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { ProjectDetailUtil } from "../../Utility/ProjectDetailUtil";
import { useLocation } from "react-router-dom";
import { Common } from "../../../../common/src";
import { config } from "../../../config/config";
import axios, { AxiosResponse } from "axios";
import dayjs from "dayjs";
import FormatUtil from "../../Utility/ProjectComUtil";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ja from "dayjs/locale/ja";

type RegLLVProps = {
  open: boolean;
  close?: () => void;
  onClose?: () => void;
  onCancel?: () => void;
};

const calenderIcon = createSvgIcon(
  <path
    fill="#ffffff"
    fillRule="evenodd"
    d="M3,9 L21,9 L21,6 L3,6 L3,9 Z M3,18 L21,18 L21,10.5 L3,10.5 L3,18 Z M18,4.5 L18,3 L16.5,3 L16.5,4.5 L7.5,4.5 L7.5,3 L6,3 L6,4.5 L1.5,4.5 L1.5,6 L1.5,19.5 L3,19.5 L21,19.5 L22.5,19.5 L22.5,6 L22.5,4.5 L18,4.5 Z"
  />,
  "Calender"
);

const leftIcon = createSvgIcon(
  <polygon
    fill="#00011D"
    fillRule="evenodd"
    points="16.5 4.5 14.378 4.5 6.876 12.002 14.378 19.505 16.5 19.505 8.998 12.002"
  />,
  "leftIcon"
);

const rightIcon = createSvgIcon(
  <polygon
    fill="#00011D"
    fillRule="evenodd"
    points="9.747 4.5 7.626 4.5 15.129 12.002 7.626 19.505 9.747 19.505 17.25 12.002"
  />,
  "rightIcon"
);

const downIcon = createSvgIcon(
  <polygon
    fill="#00011D"
    fillRule="evenodd"
    points="19.503 7.626 12 15.128 4.497 7.626 4.497 9.748 10.94 16.189 12 17.25 13.061 16.189 19.503 9.748"
  />,
  "downIcon"
);

const RegisterWithLLV = (regLLVProps: RegLLVProps) => {
  const { openError } = useContext(UseSnackbarContext);
  const { projectDetail, isJapanese, displayType, getProjectDetail } =
    useContext(ProjectDetailContext);
  const location = useLocation();
  const searchCondition =
    location.state && (location.state as any).searchCondition
      ? (location.state as any).searchCondition
      : undefined;

  const useAssets = { label: t("USING_COORD_SYSTEM"), value: "" };
  /*****************************************
      state
    ******************************************/
  const LANDLOG_LINK = process.env.REACT_APP_LLV_URL + projectDetail?.jobsiteId; // LandlogのURL
  const [coordinatesVal, setCoordinatesVal] = useState<{
    label: string;
    value: number | string;
  }>({ label: t("USING_COORD_SYSTEM"), value: " " }); // 「座標系」
  const [verticalVal, setVerticalVal] = useState<{
    label: string;
    value: number | string;
  }>({ label: t("USING_COORD_SYSTEM"), value: " " }); //「標高基準」
  const [radioCoordinates, setRadioCoordinates] = useState<string>("0"); //「点群を選択」
  const [uploadLoading, setuploadLoading] = useState<boolean>(false); //「保存ボタン」Loading
  const [uploadDialogFlag, setUploadDialogFlag] = useState<boolean>(false); //「保存ボタン」アップロード
  const [datePickerFrom, setDatePickerFrom] = useState<any>(
    searchCondition?.datePickerFrom ? searchCondition.datePickerFrom : null
  ); //「期間 From」
  const [datePickerTo, setDatePickerTo] = useState<any>(
    searchCondition?.datePickerTo ? searchCondition.datePickerTo : null
  ); //「期間 To」
  const [openDialogLLV, setOpenDialogLLV] = useState<boolean>(false); // 保存完了後、ダイアログ表示
  const [coordinateValidation, setCoordinateValidation] =
    useState<boolean>(false); // 座標系 Validation Check
  const [altitudeValidation, setAltitudeValidation] = useState<boolean>(false); // 標高基準 Validation Check
  const [dateValidation, setDateValidation] = useState<boolean>(false); // 期間 比較

  /*****************************************
      Effect
    ******************************************/
  useEffect(() => {
    // Validation Check 初期化
    setCoordinateValidation(false);
    setAltitudeValidation(false);
    setDateValidation(false);
    // ラジオボタン初期化
    setRadioCoordinates("0");
    // 保存ボタン初期化
    // 設定値初期化
    setCoordinatesVal(useAssets);
    setVerticalVal(useAssets);
    setDatePickerFrom(null);
    setDatePickerTo(null);
  }, [regLLVProps.open]);

  //「点群を選択」イベント処理
  useEffect(() => {
    if (radioCoordinates === "1" && verticalVal.value === "")
      setVerticalVal({ label: null, value: null });
    if (radioCoordinates === "1" && coordinatesVal.value === "")
      setCoordinatesVal({ label: null, value: null });
    setDatePickerTo(null);
    setDatePickerFrom(null);
    setCoordinateValidation(false);
    setAltitudeValidation(false);
    setDateValidation(false);
  }, [radioCoordinates]);

  // 保存ボタンの活性/非活性
  useEffect(() => {
    // 座標変換後のチェック
    if (coordinatesVal.value !== "" && verticalVal.value !== "") {
      if (!altitudeValidation && !coordinateValidation) {
      }
    } else {
      if (!coordinateValidation) {
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordinatesVal, verticalVal]);

  /*****************************************
      function
    ******************************************/
  //座標系の制御
  const getValueSelect = (type: string) => {
    const value = type === "cood" ? coordinatesVal.value : verticalVal.value;
    if (value === "") {
      return { label: t("USING_COORD_SYSTEM"), value: "" };
    } else {
      return (
        (type === "cood" ? cood : vertical).find((x) => x.value === value) ||
        null
      );
    }
  };

  const targetChangeVal = (e: any, v: any, d: string) => {
    if (v !== null) {
      // Enter, Numberチャック
      if (e.key === "Enter") {
        // Number Check
        if (!Number.isInteger(Number(v.value))) {
          if (d === "code") {
            setCoordinateValidation(true);
            return;
          } else {
            setAltitudeValidation(true);
            return;
          }
        }

        // 座標系 : code 標高基準: vertical
        if (d === "code") {
          setCoordinatesVal(v);
          setCoordinateValidation(false);
        } else {
          setVerticalVal(v);
          setAltitudeValidation(false);
        }
      } else {
        if (v.value === null) {
          return;
        }

        if (d === "code") {
          setCoordinatesVal(v);
          setCoordinateValidation(false);
        } else {
          setVerticalVal(v);
          setAltitudeValidation(false);
        }
      }
    } else {
      if (d === "code") setCoordinatesVal({ label: null, value: null });
      else {
        setVerticalVal({ label: null, value: null });
      }
    }
  };

  const handleUpload = async () => {
    setuploadLoading(true);
    try {
      let dateFrom = null;
      let dateTo = null;

      // 日付バリエーションチェック
      if (datePickerFrom != null && datePickerTo != null) {
        dateFrom = FormatUtil.dateFormat(datePickerFrom, isJapanese);
        dateTo = FormatUtil.dateFormat(datePickerTo, isJapanese);

        if (dateFrom === "Invalid Date" || dateTo === "Invalid Date") {
          setDateValidation(true);
          setuploadLoading(false);
          return;
        }
        // Invalid Date
        if (dateFrom > dateTo || dateFrom >= dateTo) {
          setDateValidation(true);
          setuploadLoading(false);
          return;
        }
      }

      // Body 設定
      const body = {
        type:
          radioCoordinates === "0"
            ? Common.POINT_CLOUD_TYPE.SFM
            : Common.POINT_CLOUD_TYPE.HELMERT,
        cood: coordinatesVal.value,
        vertical: verticalVal.value,
        From: datePickerFrom ? dayjs(datePickerFrom).toISOString() : "",
        To: datePickerTo ? dayjs(datePickerTo).toISOString() : "",
      };

      // APIの連携処理 post
      await axios
        .post(
          `${config.serverHost}/api/v1/project/${projectDetail?.id}/upload/llv`,
          body,
          { withCredentials: true }
        )
        .then((res: AxiosResponse<Common.ProjectDetail>) => {
          regLLVProps.close();
          setUploadDialogFlag(true);
        })
        .catch((err) => {
          if (err.response?.data === "LLV_FAILD") openError(t("LLV_ERROR"));
          else openError(t("ERROR"));
        });
    } catch (e) {
      console.error(e);
      openError(t("ERROR"));
    } finally {
      setuploadLoading(false);
      getProjectDetail();
    }
  };

  const uploadCompletionDialogClose = () => {
    setUploadDialogFlag(false);
  };

  const openLLV = () => {
    setUploadDialogFlag(false);
    if (displayType === EDisplayType.Web) {
      window.open(LANDLOG_LINK);
    } else {
      (window as any).webkit.messageHandlers.callback.postMessage({
        type: "openLLV",
        props: { siteId: projectDetail?.jobsiteId },
      });
    }
  };

  const disabledSave = () => {
    const status = projectDetail.status;
    const PROCESSING = Common.PROJECT_STATUS_ENUM.PROCESSING;
    return (
      coordinatesVal.value == null ||
      verticalVal.value == null ||
      (status &&
        ((radioCoordinates === "0" &&
          (status.coordinate_transformation === PROCESSING ||
            status.point_splitting_sfm === PROCESSING ||
            status.remove_sfm === PROCESSING ||
            status.point_txt_sfm === PROCESSING)) ||
          (radioCoordinates === "1" &&
            (status.helmert_transformation === PROCESSING ||
              status.point_splitting_helmert === PROCESSING ||
              status.remove_helmert === PROCESSING ||
              status.point_txt_helmert === PROCESSING))))
    );
  };

  /*****************************************
      style
    ******************************************/
  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customBackgroundStyles = {
    background: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const CustomCanselButton = styled(Button)({
    background: theme.palette.base.modal,
    boxShadow: "none",
    color: theme.palette.base.contrast,
    "&:hover": {
      background: theme.palette.base.modal,
      color: theme.palette.base.contrast,
      boxShadow: "none",
    },
  });

  const customLoadingButton = {
    background: theme.palette.primary.main,
    boxShadow: "none",
    "&:hover": {
      background: theme.palette.primary.main,
      boxShadow: "none",
    },
  };

  const CustomButton = styled(Button)({
    background: theme.palette.primary.main,
    boxShadow: "none",
    color: "#FFFFFF",
    height: "42px",
    width: "250px",
    outline: "none",
    textTransform: "none",
    "&:hover": {
      background: theme.palette.primary.main,
      boxShadow: "none",
    },
  });

  const cssStyles = makeStyles({
    dialogRoot: {
      "&.MuiTypography-root": { textAlign: "left", fontSize: "18px" },
    },
    selectStyle: {
      width: "538px",
      height: "35px",
      marginTop: "28px",
      right: "15px",
      textAlign: "left",
    },
    typographyStyle: { fontSize: "15px", textTransform: "none" },
    radioStyleComm: { position: "absolute", top: "80px" },
    radioStyle1: { left: "20px" },
    radioStyle2: { left: "200px" },
    isLanguageRadioStyle2: { left: "20px", maxWidth: "90%", top: "110px" },
    btn1: {
      "&.MuiButtonBase-root": {
        height: "24px",
        width: "24px",
        color: customColor.color,
        float: "right",
        fontSize: "18px",
        margin: "0px",
        padding: "0px",
        position: "absolute",
        right: "0px",
        outline: "none",
      },
    },
    btn2: {
      "&.MuiButtonBase-root": {
        height: "42px",
        width: "532px",
        top: "69px",
        left: "24px",
        background: "#0064BA",
        color: customColor.color,
        position: "absolute",
        outline: "none",
      },
    },
    btn3: {
      "&.MuiButtonBase-root": {
        height: "42px",
        width: "532px",
        top: "69px",
        left: "24px",
        background: "#0064BA",
        marginTop: "60px",
        color: customColor.color,
        position: "absolute",
        outline: "none",
      },
    },
    btn4: {
      "&.MuiButtonBase-root": {
        height: "42px",
        width: "250px",
        color: customColor.color,
        border: "1px solid #565664",
        outline: "none",
      },
    },
    btn5: {
      "&.MuiButtonBase-root": {
        height: "42px",
        width: "250px",
        outline: "none",
        textTransform: "none",
      },
    },
  });
  const userStyle = cssStyles();

  return (
    <>
      {!uploadDialogFlag && regLLVProps.open ? (
        <Dialog
          open={regLLVProps.open}
          PaperProps={{
            style: {
              width: "581px",
              height: "450px",
              boxShadow: "none",
              textAlign: "center",
              border: "1px solid #44444F",
              ...customBackgroundStyles,
            },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: customDialogBackgroundColor.color,
              },
            },
          }}
        >
          <DialogTitle className={userStyle.dialogRoot}>
            {t("UPLOAD_LANDLOG")}
            <Button
              className={userStyle.btn1}
              onClick={() => regLLVProps.close()}
            >
              ×
            </Button>
            <div style={{ borderBottom: "1px solid" }} />
          </DialogTitle>
          <DialogActions>
            <div style={{ marginTop: "5px" }}>
              <p
                style={{
                  top: "60px",
                  fontSize: "15px",
                  position: "absolute",
                  left: "23px",
                }}
              >
                {t("SELECT_POINT_CLOUD")}
              </p>
              <RadioGroup>
                <FormControlLabel
                  label={t("ORIGINAL_SFM_POINT")}
                  className={`${userStyle.radioStyleComm} ${userStyle.radioStyle1}`}
                  control={
                    <Radio
                      checked={radioCoordinates === "0"}
                      onChange={() => setRadioCoordinates("0")}
                    />
                  }
                />
                <FormControlLabel
                  label={t("TRANSFOR_SFM_POINT")}
                  disabled={
                    !ProjectDetailUtil.isHelmartComplete(projectDetail.status)
                  }
                  className={
                    isJapanese
                      ? `${userStyle.radioStyleComm} ${userStyle.radioStyle2}`
                      : `${userStyle.radioStyleComm} ${userStyle.isLanguageRadioStyle2}`
                  }
                  control={
                    <Radio
                      checked={radioCoordinates === "1"}
                      onChange={() => setRadioCoordinates("1")}
                    />
                  }
                />
              </RadioGroup>
            </div>
          </DialogActions>
          <DialogActions style={isJapanese ? {} : { marginTop: "20px" }}>
            <div style={{ marginTop: "35px" }}>
              <div
                style={{
                  fontSize: "15px",
                  position: "absolute",
                  left: "23px",
                  display: "flex",
                  gap: "4px",
                }}
              >
                <p>{t("COORDINATE_SYSTEM")}</p>
                <p className={"p-tag-required"}>{t("REQUIRED")}</p>
              </div>
              {coordinateValidation ? (
                <p
                  className={
                    isJapanese
                      ? "p-tag-comm p-tag-err-comm p-tag-err"
                      : i18n.language === "de"
                      ? "p-tag-comm p-tag-err-comm p-tag-err-language-de"
                      : "p-tag-comm p-tag-err-comm p-tag-err-language"
                  }
                >
                  {t("PLS_ENTER_BETWEEN")}
                </p>
              ) : null}
              <Autocomplete
                value={getValueSelect("cood")}
                disablePortal
                options={
                  radioCoordinates === "0"
                    ? [{ label: t("USING_COORD_SYSTEM"), value: "" }, ...cood]
                    : cood
                }
                sx={{ marginRight: "14px" }}
                onChange={(e, v) => targetChangeVal(e, v, "code")}
                ListboxProps={{ style: { maxHeight: 200, overflow: "auto" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="code"
                    sx={{
                      width: "538px",
                      marginTop: "28px",
                      ".MuiAutocomplete-inputRoot": {
                        flexWrap: "nowrap !important",
                        height: "38px",
                        textAlign: "left",
                      },
                    }}
                  />
                )}
              />
            </div>
          </DialogActions>
          <DialogActions>
            <div>
              <div
                style={{
                  fontSize: "15px",
                  position: "absolute",
                  left: "23px",
                  display: "flex",
                  gap: "4px",
                }}
              >
                <p>{t("VERTICAL_COORDINATE_SYSTEM")}</p>
                <p className={"p-tag-required"}>{t("REQUIRED")}</p>
              </div>
              {altitudeValidation ? (
                <p
                  className={
                    isJapanese
                      ? "p-tag-comm p-tag-err-comm p-tag-err1"
                      : i18n.language === "de"
                      ? "p-tag-comm p-tag-err-comm p-tag-err1-language-de"
                      : "p-tag-comm p-tag-err-comm p-tag-err1-language"
                  }
                >
                  {t("PLS_ENTER_BETWEEN")}
                </p>
              ) : null}
              <Autocomplete
                value={getValueSelect("vertical")}
                disablePortal
                options={
                  radioCoordinates === "0"
                    ? [
                        { label: t("USING_COORD_SYSTEM"), value: "" },
                        ...vertical,
                      ]
                    : vertical
                }
                sx={{ marginRight: "14px" }}
                onChange={(e, v) => targetChangeVal(e, v, "vertical")}
                ListboxProps={{ style: { maxHeight: 200, overflow: "auto" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="code"
                    sx={{
                      width: "538px",
                      marginTop: "28px",
                      ".MuiAutocomplete-inputRoot": {
                        flexWrap: "nowrap !important",
                        height: "38px",
                        textAlign: "left",
                      },
                    }}
                  />
                )}
              />
            </div>
          </DialogActions>
          <DialogActions style={{ marginRight: "14px", marginTop: "20px" }}>
            <p
              style={{
                marginBottom: "72px",
                fontSize: "15px",
                position: "absolute",
                left: "23px",
              }}
            >
              {t("PERIOD")}
            </p>
            <p
              className={
                isJapanese
                  ? "p-tag-comm p-tag3-comm p-tag3"
                  : i18n.language === "en"
                  ? "p-tag-comm p-tag3-comm p-tag3-language-en"
                  : i18n.language === "de"
                  ? "p-tag-comm p-tag3-comm p-tag3-language-de"
                  : i18n.language === "cz"
                  ? "p-tag-comm p-tag3-comm p-tag3-language-cz"
                  : "p-tag-comm p-tag3-comm p-tag3-language"
              }
            >
              {t("ANY")}
            </p>
            {dateValidation ? (
              <p
                className={
                  isJapanese
                    ? "p-tag-comm p-tag-err-comm p-tag-err2"
                    : i18n.language === "en"
                    ? "p-tag-comm p-tag-err-comm p-tag-err2-language-en"
                    : i18n.language === "de"
                    ? "p-tag-comm p-tag-err-comm p-tag-err2-language-de"
                    : i18n.language === "cz"
                    ? "p-tag-comm p-tag-err-comm p-tag-err2-language-cz"
                    : "p-tag-comm p-tag-err-comm p-tag-err2-language"
                }
              >
                {t("PLS_INPUT_DATE")}
              </p>
            ) : null}
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
              <DateTimePicker
                value={datePickerFrom}
                onChange={setDatePickerFrom}
                inputFormat={
                  isJapanese ? "YYYY/MM/DD HH:mm" : "DD/MM/YYYY HH:mm"
                }
                mask={isJapanese ? "____/__/__ __:__" : "__/__/____ __:__"}
                renderInput={(params) => {
                  params.InputProps = {
                    endAdornment: params.InputProps.endAdornment,
                    style: { width: "253px" },
                  };
                  return <TextField size="small" {...params} />;
                }}
                components={{
                  OpenPickerIcon: calenderIcon,
                  LeftArrowIcon: leftIcon,
                  RightArrowIcon: rightIcon,
                  SwitchViewIcon: downIcon,
                }}
              />
            </LocalizationProvider>
            <div>～</div>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
              <DateTimePicker
                value={datePickerTo}
                onChange={setDatePickerTo}
                inputFormat={
                  isJapanese ? "YYYY/MM/DD HH:mm" : "DD/MM/YYYY HH:mm"
                }
                mask={isJapanese ? "____/__/__ __:__" : "__/__/____ __:__"}
                renderInput={(params) => {
                  params.InputProps = {
                    endAdornment: params.InputProps.endAdornment,
                    style: { width: "253px" },
                  };
                  return <TextField size="small" {...params} />;
                }}
                components={{
                  OpenPickerIcon: calenderIcon,
                  LeftArrowIcon: leftIcon,
                  RightArrowIcon: rightIcon,
                  SwitchViewIcon: downIcon,
                }}
              />
            </LocalizationProvider>
          </DialogActions>
          <DialogActions style={{ display: "flex", justifyContent: "center" }}>
            <CustomCanselButton
              className={userStyle.btn4}
              onClick={() => regLLVProps.close()}
              variant="contained"
              size="small"
              style={{ borderRadius: "0px" }}
            >
              {t("CANCEL")}
            </CustomCanselButton>
            <LoadingButton
              loading={uploadLoading}
              disabled={disabledSave()}
              onClick={handleUpload}
              className={`${userStyle.btn5} loading-white`}
              variant="contained"
              size="small"
              style={{
                borderRadius: "0px",
                ...(disabledSave() ? null : customLoadingButton),
              }}
            >
              {t("UPLOAD")}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      ) : (
        uploadDialogFlag && (
          <Dialog
            open={uploadDialogFlag}
            PaperProps={{
              style: {
                width: "581px",
                boxShadow: "none",
                textAlign: "center",
                border: "1px solid #44444F",
                ...customBackgroundStyles,
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: customDialogBackgroundColor.color,
                },
              },
            }}
          >
            <DialogContent style={{ padding: "4px" }}>
              <DialogTitle style={{ fontSize: "16px" }}>
                {t("UPLOAD_COMPLETE_2")}
              </DialogTitle>
              <DialogActions
                style={{ display: "flex", justifyContent: "center" }}
              >
                <CustomButton
                  onClick={uploadCompletionDialogClose}
                  variant="contained"
                  size="small"
                  style={{ borderRadius: "0px" }}
                >
                  {t("CLOSE")}
                </CustomButton>
                <CustomButton
                  onClick={openLLV}
                  variant="contained"
                  size="small"
                  style={{ borderRadius: "0px" }}
                >
                  {t("LANDLOG_VIEWER")}
                </CustomButton>
              </DialogActions>
            </DialogContent>
          </Dialog>
        )
      )}
    </>
  );
};

export default RegisterWithLLV;
